export { default as DevTools } from './DevTools';



// WEBPACK FOOTER //
// ./src/components/index.js